// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3aff4abb","453":"b20f4495","634":"6b86b441"}[chunkId] + ".chunk.js";
};